import { toast } from 'sonner';

import { useModal } from '@/hooks';
import { toastError } from '@/utils';

import { useCreateUnitMutation } from '../../../../features/slice/products/unit/unit-api-slice';
import { UnitForm } from '../unit-form.component';

export const CreateUnit = () => {
    const [createUnit, { isLoading }] = useCreateUnitMutation();
    const { closeModal } = useModal();

    const handleSubmit = async (values: { name: string }) => {
        try {
            await createUnit(values).unwrap();
            toast.success('Unit has been created');
            closeModal();
        } catch (error) {
            toastError(
                error,
                'CreateUnit: handleSubmit -> Failed to create unit.',
            );
        }
    };

    return (
        <UnitForm
            initialValues={{
                name: '',
                // @ts-expect-error for optional fields
                quantity: undefined,
                strip_quantity: undefined,
            }}
            onSubmit={handleSubmit as any}
            isLoading={isLoading}
            title={'Create Unit'}
        />
    );
};
